import request from './request';
import type {
  DuplicateScanResult,
  DuplicateRecommendedResolveResult,
  ProductDuplicateGroup,
  ProductDuplicateGroupListResponse,
  ResolveDuplicateGroupPayload,
  ResolveRecommendedDuplicateGroupsPayload,
} from '../types/productDuplicate';

export const scanDuplicateProducts = async (): Promise<DuplicateScanResult> => {
  return request({
    url: '/api/products/duplicates/scan',
    method: 'POST',
    skipGlobalErrorMessage: true,
  });
};

export const getDuplicateProductGroups = async (
  status: string = 'candidate',
  page: number = 1,
  pageSize: number = 20,
): Promise<ProductDuplicateGroupListResponse> => {
  return request({
    url: '/api/products/duplicates',
    method: 'GET',
    params: { status, page, pageSize },
    skipGlobalErrorMessage: true,
  });
};

export const resolveDuplicateProductGroup = async (
  groupKey: string,
  data: ResolveDuplicateGroupPayload,
): Promise<ProductDuplicateGroup> => {
  return request({
    url: `/api/products/duplicates/${encodeURIComponent(groupKey)}/resolve`,
    method: 'POST',
    data,
    skipGlobalErrorMessage: true,
  });
};

export const resolveAllRecommendedDuplicateGroups = async (
  data: ResolveRecommendedDuplicateGroupsPayload = {},
): Promise<DuplicateRecommendedResolveResult> => {
  return request({
    url: '/api/products/duplicates/resolve-recommended',
    method: 'POST',
    data,
    skipGlobalErrorMessage: true,
  });
};
